export const PLANNING_STATES = {
  CHECK: "check",
  ALIGN: "align",
  VALIDATE: "validate",
};
